import React from "react";
import filter from "./filter.png";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useTranslation } from "react-i18next";
const ClearFiltersIcon = ({ resetFilters }) => {
  const { t } = useTranslation();
  return (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{t("clear-all-filters")}</Tooltip>}>
      <div
        className="d-flex "
        style={{
          cursor: "pointer",
          padding: "10px  0",
          marginLeft: "45px",
          marginTop: "-40px",
        }}
        onClick={resetFilters}>
        <img src={filter} width="22px" height="22px" className="d-block" />
      </div>
    </OverlayTrigger>
  );
};

export default ClearFiltersIcon;
